module.exports = __webpack_public_path__ + "static/media/angle-right-solid.ec895ad4.svg";